import React from "react";
import {
    ShieldAlert,
    ShieldCheck,
    Database,
    Users
} from "lucide-react";

export default function PlaceholderDashboard({ role }) {
    const configs = {
        admin: {
            title: "Admin Control Center",
            description: "Full system visibility and user management.",
            icon: ShieldAlert,
            color: "text-red-600 bg-red-50",
        },
        agent: {
            title: "Customs Agent Portal",
            description: "Manage client projects and compliance logging.",
            icon: ShieldCheck,
            color: "text-blue-600 bg-blue-50",
        },
        "3pl": {
            title: "3PL Partner Dashboard",
            description: "Operational data exchange and stock visibility.",
            icon: Database,
            color: "text-emerald-600 bg-emerald-50",
        },
        customer: {
            title: "Customer Visibility Portal",
            description: "Track your orders and receive updates from SMEs.",
            icon: Users,
            color: "text-amber-600 bg-amber-50",
        }
    };

    const config = configs[role] || configs.admin;
    const Icon = config.icon;

    return (
        <div className="max-w-4xl mx-auto py-12 px-6 text-center">
            <div className={`w-20 h-20 rounded-2xl ${config.color} flex items-center justify-center mx-auto mb-6 shadow-sm`}>
                <Icon size={40} />
            </div>
            <h1 className="text-3xl font-bold text-navy-900 font-serif mb-2">{config.title}</h1>
            <p className="text-slate-500 text-lg mb-8">{config.description}</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <h3 className="font-bold text-navy-900 mb-2">Overview</h3>
                    <p className="text-sm text-slate-500">View real-time status and high-level metrics for your role.</p>
                </div>
                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <h3 className="font-bold text-navy-900 mb-2">Recent Activity</h3>
                    <p className="text-sm text-slate-500">Monitor latest updates and system events relevant to you.</p>
                </div>
                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <h3 className="font-bold text-navy-900 mb-2">Quick Actions</h3>
                    <p className="text-sm text-slate-500">Access your primary tools and common workflows quickly.</p>
                </div>
            </div>

            <div className="mt-12 p-8 bg-gold-50 rounded-2xl border border-gold-100 flex items-center justify-between gap-6">
                <div className="text-left">
                    <h2 className="text-xl font-bold text-navy-900">Module Under Development</h2>
                    <p className="text-slate-600 mt-1">We are currently migrating specific features to this role-based portal.</p>
                </div>
                <button className="bg-navy-900 text-white px-6 py-2.5 rounded-lg font-bold shadow-lg shadow-navy-900/20">
                    Request Access
                </button>
            </div>
        </div>
    );
}
